/** VistoeraTASK-00345 — expanded generation nodes: transparent left ingress
 * corridor so inbound edges (z-index 1) remain visible above the gutter
 * while semantic Handles stay at slot left-center (00341/00342). */

/** Visible ingress strip width — edges render in this transparent band. */
export const GENERATION_SLOT_INGRESS_WIDTH_PX = 28

export const GENERATION_SLOT_INGRESS_CLASS = 'pcv-node--generation-slot-ingress'

export function generationSlotIngressShellClass(expanded: boolean): string {
  return expanded ? GENERATION_SLOT_INGRESS_CLASS : ''
}
